import { VirtualRepeat } from './virtual-repeat';
import { CollectionStrategyLocator } from './collection-strategy';
import { ScrollerObserverLocator } from './scroller-observer';
import { DefaultDomRenderer } from './virtual-repeat-dom-renderer';
export const DefaultVirtualRepeatConfiguration = {
    register(container) {
        return container.register(ScrollerObserverLocator, CollectionStrategyLocator, DefaultDomRenderer, VirtualRepeat);
    }
};
